import { SwadeshTagProps } from './generated/interface';

export const withLogic =
  (
    Component: React.ComponentType<SwadeshTagProps>
  ): React.FC<SwadeshTagProps> =>
  (props: SwadeshTagProps) => {
    return <Component {...props} />;
  };
